import axios from '../resources/config/axios';

const USER_ENDPOINT = 'api/users/';
const LOG_USER_LDAP = 'api/users/connect';
const UTILISATEUR_COURANT = 'api/users/utilisateur-courant';
const PARAM_ACCUEIL = 'api/users/getParamAccueil';

export const getUtilisateurCourant = () => axios.get(UTILISATEUR_COURANT);

export const registerUser = user => axios.post(USER_ENDPOINT, user);

export const getAllUsers = () => axios.get(USER_ENDPOINT);

export const logUserSSO = () => axios.post(
  LOG_USER_LDAP,
);

export const getParamAccueil = () => axios.get(PARAM_ACCUEIL);
